import { ArrowRight, CheckCircle2, XCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function CountryCard({ country, onClick, animationIndex }) {
  return (
    <div
      onClick={onClick}
      className={`card p-3 cursor-pointer hover:border-violet-300 hover:shadow-md transition-all animate-fade-in stagger-${(animationIndex % 8) + 1}`}
      data-testid={`country-card-${country.country_code}`}
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="text-2xl">{country.flag_emoji}</span>
        <div className="min-w-0 flex-1">
          <h3 className="font-semibold text-zinc-800 text-sm truncate">{country.country_name}</h3>
          <span className="text-xs text-zinc-400">{country.country_code}</span>
        </div>
      </div>
      
      <div className="space-y-1 text-xs">
        <div className="flex items-center justify-between">
          <span className="text-zinc-500">Currency</span>
          <Badge variant="outline" className="text-xs px-1.5 py-0">{country.currency}</Badge>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-zinc-500">Packaging</span>
          {country.has_packaging_epr ? (
            <CheckCircle2 className="w-3.5 h-3.5 text-green-500" />
          ) : (
            <XCircle className="w-3.5 h-3.5 text-zinc-300" />
          )}
        </div>
        <div className="flex items-center justify-between">
          <span className="text-zinc-500">WEEE</span>
          {country.has_weee ? (
            <CheckCircle2 className="w-3.5 h-3.5 text-green-500" />
          ) : (
            <XCircle className="w-3.5 h-3.5 text-zinc-300" />
          )}
        </div>
        <div className="flex items-center justify-between">
          <span className="text-zinc-500">Main PRO</span>
          <span className="text-xs text-zinc-600 truncate max-w-[100px]">{country.main_pro}</span>
        </div>
      </div>

      <div className="mt-2 pt-2 border-t border-zinc-100">
        <button className="text-violet-600 text-xs font-medium flex items-center gap-1 hover:gap-2 transition-all">
          View Details <ArrowRight className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
}
